// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { luksoTestnet as _luksoTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the luksoTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 4201
 * Chain Name: LUKSO Testnet
 * Default Block Explorer: https://explorer.execution.testnet.lukso.network
 * Default RPC URL: https://rpc.testnet.lukso.network
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { luksoTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: luksoTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const luksoTestnet = createCommon({
	..._luksoTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
